export enum SupportedLanguage {
  EN = 'en',
  ZH_HANT_HK = 'zh-hant-hk',
  ZH_HANS = 'zh-hans',
}
